import { useCallback, useState } from 'react';
import { clearSessionJSONItem, getSessionJSONItem, setSessionJSONItem } from '@/lib/utils';
import { RECENT_SEARCH_KEY, RECENT_SEARCH_LIMIT } from '../search-constants';

export function useRecentSearchSession(): {
    recentSearches: string[];
    saveRecentSearch: (searchText: string) => void;
    clearRecentSearches: () => void;
    removeRecentSearch: (label: string) => void;
} {
    const [recentSearches, setRecentSearches] = useState<string[]>(
        () => getSessionJSONItem<string[]>(RECENT_SEARCH_KEY) || []
    );

    const saveRecentSearch = useCallback((searchText: string) => {
        let searches = getSessionJSONItem<string[]>(RECENT_SEARCH_KEY) || [];
        searches = searches.filter((savedSearchTerm) => searchText.toLowerCase() !== savedSearchTerm.toLowerCase());
        searches = [searchText, ...searches].slice(0, RECENT_SEARCH_LIMIT);
        setSessionJSONItem(RECENT_SEARCH_KEY, searches);
        setRecentSearches(searches);
    }, []);

    const clearRecentSearches = useCallback(() => {
        clearSessionJSONItem(RECENT_SEARCH_KEY);
        setRecentSearches([]);
    }, []);

    const removeRecentSearch = useCallback((label: string) => {
        const searches = (getSessionJSONItem<string[]>(RECENT_SEARCH_KEY) || []).filter(
            (saved) => saved.toLowerCase() !== label.toLowerCase()
        );
        setSessionJSONItem(RECENT_SEARCH_KEY, searches);
        setRecentSearches(searches);
    }, []);

    return { recentSearches, saveRecentSearch, clearRecentSearches, removeRecentSearch };
}
